import { useContext, useMemo } from "react";

import { CarrierCard } from "~/features/quote/components/carrier-selection/components/carrier-card/carrier-card.tsx";
import { useRoutingGuideToggle } from "~/features/quote/components/carrier-selection/components/shared/hooks/use-routing-guide-toggle.ts";
import { RoutingGuideBanner } from "~/features/quote/components/carrier-selection/components/shared/routing-guide-banner.tsx";
import { QuoteDetailsContext } from "~/features/quote/context/quote-details-context.tsx";

import * as styles from "./carrier-select-simulate.module.css";

export const CarrierSelectSimulate = () => {
	const { quoteState } = useContext(QuoteDetailsContext);

	const allCarriers = quoteState.carrierPrices || [];

	const {
		isGuideActive,
		showingHidden,
		trigger,
		filteredCarriers,
		hiddenCarrierCount,
		handleToggleGuide,
		handleToggleHiddenCarriers,
	} = useRoutingGuideToggle(allCarriers);

	const noRoutingGuideHeader = useMemo(() => {
		if (quoteState.hasRoutingGuideMatch && filteredCarriers.length === 0) {
			return (
				<div className={styles.noRoutingGuide}>
					<p>
						No Carriers applicable please reach out to your Account
						Representative for assistance.
					</p>
				</div>
			);
		}
		return null;
	}, [filteredCarriers.length, quoteState.hasRoutingGuideMatch]);

	if (allCarriers.length === 0) {
		return (
			<div className={styles.noCarriers}>
				<p>No carriers to display</p>
			</div>
		);
	}

	return (
		<div>
			{noRoutingGuideHeader}
			{filteredCarriers.map((carrier) => (
				<CarrierCard
					key={carrier.uniqueKey}
					bannerType={trigger}
					carrierPrice={carrier}
					isBookingDisabled={Boolean(
						isGuideActive && carrier.routingGuideApplied !== true,
					)}
					isSimulated={true}
					onStepChange={() => undefined}
					pageData={undefined}
				/>
			))}
			<RoutingGuideBanner
				hasRoutingGuides={Boolean(quoteState.hasRoutingGuideMatch)}
				hiddenCarrierCount={hiddenCarrierCount}
				isGuideActive={isGuideActive}
				onToggleGuide={handleToggleGuide}
				onToggleHiddenCarriers={handleToggleHiddenCarriers}
				showingHidden={showingHidden}
			/>
		</div>
	);
};
